import PropTypes from 'prop-types';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { BsCheckLg, BsArrowReturnLeft } from 'react-icons/bs';
import { AiOutlineReload } from 'react-icons/ai';

import { useWorkReportModals } from '../../../../../context/WorkReportModalsContext';
import {
  workReportLineStatus as workLineString,
  OWSincronizationStatus
} from '../../../../../constants/constants';
import {
  assignmentTypeEnum,
  ubicationTypeEnum,
  workReportLineStatus
} from '../../../../../utils/dataStatus';
import './LineRowApprovalPending.scss';
import { partesTrabajoDiarioItemsWorkReport } from '../../../../../utils/globalPropTypes';
import { AttachedFilesPermissions } from '../../../../MonthlyServiceRequest/RequestDetailTypes';
import ActionButtonApproval from '../ActionButtonApproval';
import { setInputBackgroundColor } from '../../../../../utils/workReportLinesUtils';

const STATES_WITH_ICONS_OW = [
  workReportLineStatus.devolver,
  workReportLineStatus.fijar,
  workReportLineStatus.aprobar
];

const LineRowApprovalPending = ({
  cantidad,
  dailyWorkReport,
  fetchData,
  lineaSap,
  posicionSap,
  selectedDate,
  selectedInput,
  showApproveButton,
  showRejectButton,
  showEditButton,
  unidadMedida,
  permissions,
  showPPButton
}) => {
  const { activeMonthlySummaryModal } = useWorkReportModals();
  // Estados de Open Wells
  const isChecked = dailyWorkReport?.iconoEnum === OWSincronizationStatus.check;
  const isSynchronizing = dailyWorkReport?.iconoEnum === OWSincronizationStatus.sincronizacion;
  const isReturned = dailyWorkReport?.iconoEnum === OWSincronizationStatus.devolver;

  const visualizeOWStatus = STATES_WITH_ICONS_OW.includes(dailyWorkReport.estadoEnum);

  const showMonthlySummaryModal = () => {
    activeMonthlySummaryModal({
      dailyWorkReport: {
        ...dailyWorkReport,
        date: selectedDate
      },
      monthly: dailyWorkReport.tipoAsignacion === assignmentTypeEnum.Mensualizada,
      filesPermissions: permissions
    });
  };

  const setIconOW = () => {
    if (visualizeOWStatus) {
      if (isChecked) return <BsCheckLg />;
      if (isSynchronizing) return <AiOutlineReload />;
      if (isReturned) return <BsArrowReturnLeft />;
    }

    return null;
  };

  const renderCantidad = () => {
    if (selectedInput === 'PENDIENTES') {
      return <p className="description-cantidad mt-2 d-flex ">{cantidad}</p>;
    }

    return (
      <OverlayTrigger
        delay={{
          show: 250,
          hide: 400
        }}
        overlay={
          <Tooltip id="button-tooltip">{`
            ${workLineString[dailyWorkReport.estadoEnum]}
            ${visualizeOWStatus && isSynchronizing ? ' - Sincronizando' : ''}`}</Tooltip>
        }
        placement="top"
      >
        <div className={`edit-relative ${setInputBackgroundColor({ dailyWorkReport })} `}>
          {cantidad}
          {setIconOW()}
        </div>
      </OverlayTrigger>
    );
  };

  return (
    <>
      <div className="line-row-wraper px-3 div">
        <Row className="d-flex align-items-center">
          <Col className="gy-0" sm={3}>
            <OverlayTrigger
              delay={{
                show: 250,
                hide: 400
              }}
              overlay={<Tooltip id="button-tooltip">{posicionSap?.toUpperCase()}</Tooltip>}
              placement="top"
            >
              <p
                className="description-position mt-2"
                onClick={showMonthlySummaryModal}
                role="none"
              >
                {posicionSap?.toUpperCase()}
              </p>
            </OverlayTrigger>
          </Col>
          <Col sm={3}>
            <OverlayTrigger
              delay={{
                show: 250,
                hide: 400
              }}
              overlay={<Tooltip id="button-tooltip">{lineaSap?.toUpperCase()}</Tooltip>}
              placement="top"
            >
              <p className="description-line mt-2" onClick={showMonthlySummaryModal} role="none">
                {lineaSap?.toUpperCase()}
              </p>
            </OverlayTrigger>
          </Col>
          <Col sm={1}>
            <p className="description-um mt-2">{unidadMedida?.toUpperCase()}</p>
          </Col>
          <Col sm={2}>{renderCantidad()}</Col>
          <Col className="p-0" sm={selectedInput === 'PENDIENTES' ? 3 : 2}>
            <ActionButtonApproval
              dailyWorkReport={dailyWorkReport}
              fetchData={fetchData}
              selectedDate={selectedDate}
              visibleAccept={showApproveButton}
              visibleCod
              visibleEdit={showEditButton}
              visiblePP={
                showPPButton && dailyWorkReport?.tipoUbicacionEnum === ubicationTypeEnum.pozo
              }
              visibleReject={showRejectButton}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

LineRowApprovalPending.propTypes = {
  cantidad: PropTypes.number.isRequired,
  dailyWorkReport: partesTrabajoDiarioItemsWorkReport.isRequired,
  fetchData: PropTypes.func.isRequired,
  lineaSap: PropTypes.shape({
    toUpperCase: PropTypes.func
  }).isRequired,
  posicionSap: PropTypes.shape({
    toUpperCase: PropTypes.func
  }).isRequired,
  selectedDate: PropTypes.string.isRequired,
  selectedInput: PropTypes.string.isRequired,
  showApproveButton: PropTypes.bool.isRequired,
  showRejectButton: PropTypes.bool.isRequired,
  showEditButton: PropTypes.bool.isRequired,
  unidadMedida: PropTypes.shape({
    toUpperCase: PropTypes.func
  }).isRequired,
  permissions: AttachedFilesPermissions,
  showPPButton: PropTypes.bool.isRequired
};
export default LineRowApprovalPending;

LineRowApprovalPending.defaultProps = {
  permissions: {
    visualize: false,
    write: false
  }
};
